import { useEffect } from "react";
import { getRealtimeSocket } from "realtime/socketClient";
import { useChatUnread } from "context/ChatUnreadContext";

/**
 * Subscribes to `chat:message` for unread badge updates. Lives in the header so
 * it mounts whenever the shell is visible and re-binds when the socket connects
 * (child effects can run before `useRealtimeSocket` connects otherwise).
 */
export function ChatUnreadSocketListener() {
  const { socketConnected, handleChatMessageSocket } = useChatUnread();

  useEffect(() => {
    const s = getRealtimeSocket();
    if (!s || !socketConnected) return;
    s.on("chat:message", handleChatMessageSocket);
    return () => {
      s.off("chat:message", handleChatMessageSocket);
    };
  }, [socketConnected, handleChatMessageSocket]);

  return null;
}
